import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryQuickNav() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">题材分类</h2>
          <p className="mt-1 text-sm text-foreground-500">按感兴趣的题材，快速找到你的下一篇心动</p>
        </div>
        <Link
          to="/category/all"
          className="hidden shrink-0 items-center gap-1 text-sm text-primary-600 transition-colors hover:text-primary-700 sm:flex"
        >
          查看全部
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 md:gap-4 lg:grid-cols-8">
        {categories.map((c) => (
          <Link
            key={c.key}
            to={`/category/${c.key}`}
            className="group flex flex-col items-center gap-2 rounded-lg border border-background-200/80 bg-background-50 px-3 py-5 transition-colors duration-300 hover:border-primary-300 hover:bg-primary-50 cursor-pointer"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${c.icon} text-xl`} />
            </span>
            <span className="text-sm font-medium text-foreground-800">{c.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}